import Button from 'components/atoms/Button';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import fileSaver from 'file-saver';
import { useContext } from 'react';
import { useState } from 'react';
import api from 'services/api';
import './styles.scss';

const initialClassificacaoState = {
    ID: '',
    Tipo: '',
    Titulo: '',
    Ativo: false,
    TipoDoc: 1,
};

//Classification Title Types
const tipo = {
    1: 'Sistema',
    2: 'Natureza',
    3: 'Finalidade',
};

function Table({ headers = ['Código', 'Arquivo', 'Versão', 'Data de Cadastro'], rows, visual = 'versions', setClassificacoes, setTotalPages, tipoDoc }) {
    const [classificacao, setClassificacao] = useState(initialClassificacaoState);
    const { pagination, user, setLoading, setResponseMsg } = useContext(GlobalContext);

    function handleOnChange(e) {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setClassificacao((prevState) => ({ ...prevState, [e.target.name]: value }));
    }

    function handleEdit(row) {
        setClassificacao(row);
    }

    //Convert byte array stream from server to pdf
    async function handleDownload(row) {
        try {
            const { data } = await api.getArquivo(row.ID, row.TipoDoc);
            const blob = new File([data], { type: 'application/pdf' });
            fileSaver.saveAs(blob, row.NomeArquivo);
        } catch (error) {
            console.error(error.message);
        }
    }

    function handleNew() {
        setClassificacao(initialClassificacaoState);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const sendData = classificacao.ID
            ? classificacao
            : {
                Tipo: e.target.Tipo.value,
                Titulo: e.target.Titulo.value,
                Ativo: e.target.Ativo.checked,
                TipoDoc: 1,
            };

        try {
            await api.postClassificacao(user, sendData);
            await api.getClassificacoesPaginated(pagination.minPage, pagination.limit).then((response) => {
                setClassificacoes(response.data.Item);
                setTotalPages(0);
                setTotalPages(Math.ceil(response.data.ID / pagination.limit));
                setClassificacao(initialClassificacaoState);
            });
        } catch (error) {
            console.error(error);
            setResponseMsg({ isVisible: true, error: true, msg: error.message });
        } finally {
            setLoading(false);
        }
    }

    async function handleDelete(id) {
        try {
            await api.deleteClassificacoes(user, id);
            await api.getClassificacoesPaginated(pagination.minPage, pagination.limit).then((response) => {
                setClassificacoes(response.data.Item);
                setTotalPages(0);
                setTotalPages(Math.ceil(response.data.ID / pagination.limit));
            });
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <section className="table">
            <header className="table__header">
                {headers.map((header, index) => (
                    <div key={index} className="header__cell">
                        {header}
                    </div>
                ))}
            </header>
            <div className="table__body">
                {visual === 'versions' ? (
                    rows?.map((row) => {
                        return (
                            <div className="body__row" key={row.ID}>
                                <div className="body__cell">{row.NRDocumento}</div>
                                <div className="body__cell">
                                    <a href={api.getArquivo(row?.ID, tipoDoc, true)} download target="_blank" rel="noreferrer" >
                                        {row.NomeArquivo}
                                    </a>
                                </div>
                                <div className="body__cell">{row.Versao}</div>
                                <div className="body__cell">{new Date(row?.DTCadastro).toLocaleDateString()}</div>
                            </div>
                        );
                    })
                ) : (
                    <>
                        <form onSubmit={handleSubmit} className="body__row body__row__form">
                            <input type="text" style={{ display: 'none' }} value={classificacao.ID} readOnly />
                            <div className="body__cell">
                                <select type="text" name="Tipo" required onChange={handleOnChange} value={classificacao.Tipo}>
                                    <option value="1">{tipo[1]}</option>
                                    <option value="2">{tipo[2]}</option>
                                    <option value="3">{tipo[3]}</option>
                                </select>
                            </div>
                            <div className="body__cell">
                                <input type="text" name="Titulo" required onChange={handleOnChange} value={classificacao.Titulo} />
                            </div>
                            <div className="body__cell">
                                <input type="checkbox" name="Ativo" onChange={handleOnChange} checked={classificacao.Ativo} />
                            </div>
                            <div className="body__cell">
                                <div className="header__button">
                                    <Button visual="save" title="Salvar" />
                                    <Button visual="add" title="Novo" type="button" onClick={handleNew} />
                                </div>
                            </div>
                        </form>
                        {rows?.map((row) => (
                            <div className="body__row" key={row.ID}>
                                <div className="body__cell">{tipo[row.Tipo]}</div>
                                <div className="body__cell">{row.Titulo}</div>
                                <div className="body__cell">{row.Ativo ? 'Sim' : 'Não'}</div>
                                <div className="body__cell">
                                    <div className="table__buttons">
                                        <Button visual="edit" title="Editar" onClick={() => handleEdit(row)} />
                                        <Button visual="delete" title="Apagar" onClick={() => handleDelete(row.ID)} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </section>
    );
}

export default Table;
